
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getSubcategoriesForType, getUnitsForSubcategory } from "./unit-categories";
import { unitAbbreviations } from "./unit-abbreviations";

interface UnitSelectProps {
  measurementType: string;
  value: string;
  onValueChange: (value: string) => void;
  label: string;
  placeholder: string;
}

export function UnitSelect({
  measurementType,
  value,
  onValueChange,
  label,
  placeholder,
}: UnitSelectProps) {
  const subcategories = getSubcategoriesForType(measurementType as keyof typeof import("./unit-categories").unitCategories);

  const formatUnitDisplay = (unit: string) => {
    const abbr = unitAbbreviations[unit];
    return (
      <span className="flex items-center gap-1.5">
        <span>{unit}</span>
        {abbr && (
          <span className="text-manuscript-primary/60 font-light">
            ({abbr})
          </span>
        )}
      </span>
    );
  };

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-manuscript-primary block">
        {label}
      </label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="h-12 md:h-10 text-base md:text-sm">
          <SelectValue placeholder={placeholder}>
            {value && formatUnitDisplay(value)}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="z-50 max-h-80">
          {subcategories.map((subcategory) => (
            <SelectGroup key={subcategory}>
              <SelectLabel className="capitalize text-base md:text-sm">{subcategory}</SelectLabel>
              {getUnitsForSubcategory(measurementType, subcategory).map((unit) => (
                <SelectItem key={unit} value={unit} className="text-base md:text-sm py-3 md:py-1.5">
                  {formatUnitDisplay(unit)}
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
